import axios from 'axios';

const regionalApi = axios.create({
	baseURL: '/api/regional-auth/v1.0',
	withCredentials: true,
});

export default regionalApi;
